import posthog from "posthog-js";

export function enablePostHogErrorTracking(mainAdminInfo = {}) {
  const baseProps = {
    adminEmail: mainAdminInfo.email || null,
    adminUid: mainAdminInfo.uid || null,
    isEmployee: mainAdminInfo.isEmployee || false,
  };

  window.onerror = function (message, source, lineno, colno, error) {
    posthog.capture("JS Error", {
      ...baseProps,
      message: message?.toString(),
      source,
      lineno,
      colno,
      stack: error?.stack || null,
    });
  };

  window.onunhandledrejection = function (event) {
    posthog.capture("Unhandled Promise Rejection", {
      ...baseProps,
      reason: event.reason?.toString(),
      stack: event.reason?.stack || null,
    });
  };
}
